import { useParams } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import { useEffect, useState } from "react";
import Api, { FinanceReportResponse } from "../../Api";
import { intToBrl } from "../../utils";
import DiscreetMessage from "../../parts/DiscreetMessage";

const FinanceReport = () => {
  const { companyUuid, year, month } = useParams();
  const [data, setData] = useState<FinanceReportResponse | null>(null);

  useEffect(() => {
    Api.financeReport(companyUuid!, `${year}/${month}`).then(setData);
  }, [companyUuid, year, month]);

  if (!data) {
    return <DiscreetMessage text="Carregando ..." />;
  }

  return (
    <div>
      <div className="p-4 text-center">
        <span className="text-lg font-bold">{data.company.shortName}</span>
        <span className="text-gray-500">
          {" / "}
          {_.upperFirst(
            moment(`${year}/${month}`, "YYYY/MM").format("MMMM \\d\\e YYYY")
          )}
        </span>
      </div>

      <div className="pb-32">
        <table className="w-[700px] m-auto text-sm">
          <thead>
            <tr className="border-b-2">
              <th>#</th>
              <th>Emissão</th>
              <th>Cliente</th>
              <th>CPF/CNPJ</th>
              <th>Valor</th>
              <th>Situação</th>
            </tr>
          </thead>

          <tbody>
            {data.items.map(({ receipt, client }) => (
              <tr
                key={receipt.uuid}
                className="border-b hover:bg-slate-50 cursor-pointer"
                onClick={() =>
                  window.open(`/externo/nota-fatura/${receipt.externalHash}`)
                }
              >
                <td className="p-1.5 border-r">{receipt.number}</td>
                <td className="p-1.5 border-r">
                  {moment(receipt.date).format("DD/MM/YY")}
                </td>
                <td className="p-1.5 border-r">{client.name}</td>
                <td className="p-1.5 border-r whitespace-nowrap">
                  {client.document}
                </td>
                <td className="p-1.5 border-r whitespace-nowrap">
                  {intToBrl(receipt.amount)}
                </td>
                <td className="p-1.5">
                  {receipt.canceled ? "Cancelada" : "OK"}
                </td>
              </tr>
            ))}

            {data.items.length === 0 && (
              <tr>
                <td colSpan={6}>
                  <DiscreetMessage text="Vazio" />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FinanceReport;
